import type {
  CreateFolderInput,
  ListFoldersResult,
  ProjectFolder,
  UpdateFolderInput,
} from '@terafile/shared'
import { apiFetch } from './api.js'

export async function listFolders(): Promise<ListFoldersResult> {
  return apiFetch<ListFoldersResult>('/folders')
}

export async function createFolder(input: CreateFolderInput): Promise<ProjectFolder> {
  return apiFetch<ProjectFolder>('/folders', {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

export async function updateFolder(id: string, input: UpdateFolderInput): Promise<ProjectFolder> {
  return apiFetch<ProjectFolder>(`/folders/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  })
}

export async function deleteFolder(id: string): Promise<void> {
  await apiFetch<{ id: string }>(`/folders/${id}`, { method: 'DELETE' })
}
